import type { ReactNode } from 'react';
import './layout.css';

export interface CenteredCardLayoutProps {
  children: ReactNode;
}

/** Centered single-card ("sign-in") layout for /login, /onboarding, /auth/complete, /error. */
export function CenteredCardLayout({ children }: CenteredCardLayoutProps) {
  return (
    <div className="centered">
      <div className="signin-card">
        <div className="signin-card__body">{children}</div>
      </div>
    </div>
  );
}

/** Two-line brand lockup: 32px icon + "WaterCorp" over "Connect". */
export function Brand() {
  return (
    <div className="brand">
      <img className="brand__logo" src="/realtime-icon.png" alt="" aria-hidden="true" />
      <span className="brand__text">
        <span className="brand__name">WaterCorp</span>
        <span className="brand__sub">Connect</span>
      </span>
    </div>
  );
}
